var map = {
	"./Button/Button/Button/eye-3.svg": 45879,
	"./Settings.svg": 32140,
	"./active-list-1.svg": 45584,
	"./active-list-2.svg": 2627,
	"./active-list-3.svg": 87986,
	"./ad-block-circle.svg": 28537,
	"./align-bottom-active.svg": 57549,
	"./align-bottom.svg": 39286,
	"./align-center-active.svg": 77775,
	"./align-center.svg": 93076,
	"./align-top-active.svg": 9239,
	"./align-top.svg": 34732,
	"./amex.svg": 38406,
	"./angle-white-right.svg": 20245,
	"./api-email.svg": 34634,
	"./arrow-cookie.svg": 86157,
	"./avatar-placeholder.svg": 38684,
	"./avatar.svg": 10256,
	"./btn-pilled.svg": 24724,
	"./btn-rounded.svg": 83633,
	"./btn-squared.svg": 45149,
	"./bucket.svg": 78345,
	"./chevron-down.svg": 79573,
	"./chevron-left.svg": 12526,
	"./chevron-toggle.svg": 52669,
	"./chevron.svg": 66180,
	"./chevron2.svg": 28990,
	"./close.svg": 35837,
	"./copy-2.svg": 96037,
	"./delete-primary.svg": 80511,
	"./delete.svg": 90930,
	"./desktop-2.svg": 94660,
	"./desktop-active.svg": 34360,
	"./desktop.svg": 2037,
	"./dot menu-primary.svg": 46612,
	"./dot-menu.svg": 23876,
	"./edit.svg": 975,
	"./elements.svg": 41776,
	"./eye-3.svg": 76842,
	"./eye-disable.svg": 79557,
	"./eye.svg": 34426,
	"./folder.svg": 30811,
	"./form-settings.svg": 86405,
	"./hamburger-menu.svg": 53140,
	"./info-green.svg": 72757,
	"./left-arrow.svg": 92104,
	"./levels.svg": 14986,
	"./list-1-icon.svg": 92469,
	"./list-1.svg": 54369,
	"./list-2-icon.svg": 36812,
	"./list-2.svg": 49330,
	"./list-3-icon.svg": 14455,
	"./list-3.svg": 52643,
	"./logo-e copy.svg": 4995,
	"./logo-e-muted.svg": 20870,
	"./logo-e.svg": 4236,
	"./logo.svg": 26962,
	"./main-logo.svg": 7868,
	"./master-card.svg": 72140,
	"./menu-dots.svg": 33639,
	"./menu-sections/About Us-active.svg": 65478,
	"./menu-sections/About Us.svg": 77543,
	"./menu-sections/Breadcrumb-active.svg": 3728,
	"./menu-sections/Breadcrumb.svg": 16669,
	"./menu-sections/Carousel-active.svg": 29759,
	"./menu-sections/Carousel.svg": 1828,
	"./menu-sections/Footer-active.svg": 48206,
	"./menu-sections/Footer.svg": 29055,
	"./menu-sections/Paragraph-active.svg": 58355,
	"./menu-sections/Paragraph.svg": 63696,
	"./menu-sections/Pricing-active.svg": 38735,
	"./menu-sections/Pricing.svg": 99092,
	"./menu-sections/Vector.svg": 13651,
	"./menu-sections/actions-active.svg": 76986,
	"./menu-sections/actions.svg": 89507,
	"./menu-sections/alert-bar-active.svg": 9819,
	"./menu-sections/alert-bar.svg": 95336,
	"./menu-sections/blog-active.svg": 64693,
	"./menu-sections/blog.svg": 29678,
	"./menu-sections/call-to-actions.svg": 87062,
	"./menu-sections/cards.svg": 46139,
	"./menu-sections/collapse-active.svg": 29630,
	"./menu-sections/collapse.svg": 70479,
	"./menu-sections/contact-forms-active.svg": 47767,
	"./menu-sections/contact-forms.svg": 44844,
	"./menu-sections/empty-blocks-active.svg": 94907,
	"./menu-sections/empty-blocks.svg": 42472,
	"./menu-sections/faq.svg": 37310,
	"./menu-sections/featured-active.svg": 81347,
	"./menu-sections/featured.svg": 91648,
	"./menu-sections/headlines-active.svg": 69096,
	"./menu-sections/headlines.svg": 261,
	"./menu-sections/hero-active.svg": 45605,
	"./menu-sections/hero.svg": 65278,
	"./menu-sections/images-active.svg": 38007,
	"./menu-sections/images.svg": 62092,
	"./menu-sections/internal-embed-block.svg": 55445,
	"./menu-sections/left-2.svg": 58956,
	"./menu-sections/left-quote-active.svg": 8717,
	"./menu-sections/left-quote.svg": 28950,
	"./menu-sections/list-active.svg": 74361,
	"./menu-sections/list.svg": 94890,
	"./menu-sections/logos.svg": 49550,
	"./menu-sections/main-2.svg": 12336,
	"./menu-sections/navbar-active.svg": 81935,
	"./menu-sections/navbar.svg": 97300,
	"./menu-sections/newsLetter-active.svg": 87150,
	"./menu-sections/newsLetter.svg": 51231,
	"./menu-sections/option-forms-active.svg": 87778,
	"./menu-sections/option-forms.svg": 95163,
	"./menu-sections/others-active.svg": 3466,
	"./menu-sections/others.svg": 6291,
	"./menu-sections/quote.svg": 25194,
	"./menu-sections/quotes-active.svg": 83320,
	"./menu-sections/quotes.svg": 70101,
	"./menu-sections/resource-active.svg": 28973,
	"./menu-sections/resource.svg": 84598,
	"./menu-sections/showcase-active.svg": 56436,
	"./menu-sections/showcase.svg": 89609,
	"./menu-sections/testimonials-active.svg": 81297,
	"./menu-sections/testimonials.svg": 13426,
	"./menu-sections/textAndImage-active.svg": 1176,
	"./menu-sections/textAndImage.svg": 3829,
	"./menu-sections/time-active.svg": 62188,
	"./menu-sections/time.svg": 34513,
	"./menu-sections/timer.svg": 79153,
	"./menu-sections/utils-active.svg": 7488,
	"./menu-sections/utils.svg": 15853,
	"./menu-sections/videos-active.svg": 32745,
	"./menu-sections/videos.svg": 70746,
	"./modules 1.svg": 37323,
	"./move-gray.svg": 75636,
	"./move-primary.svg": 18418,
	"./move.svg": 45299,
	"./payment-systems/amex.svg": 63132,
	"./payment-systems/diners-club.svg": 73723,
	"./payment-systems/discover.svg": 80992,
	"./payment-systems/master-card.svg": 59814,
	"./payment-systems/paypal.svg": 52668,
	"./payment-systems/visa.svg": 1410,
	"./paypal.svg": 65110,
	"./pdf-icon.svg": 57447,
	"./plus-gray.svg": 55001,
	"./plus-section.svg": 28785,
	"./plus-white.svg": 36891,
	"./plus.svg": 24491,
	"./pollite.svg": 46444,
	"./positive-vote.svg": 89179,
	"./quote-1.svg": 76083,
	"./quote-2.svg": 31424,
	"./resize.svg": 96599,
	"./restore.svg": 18575,
	"./right-arrow.svg": 14263,
	"./rows.svg": 59172,
	"./search.svg": 64343,
	"./shadow-none.svg": 11414,
	"./slider-left.svg": 35946,
	"./slider-right.svg": 47713,
	"./smartphone-2.svg": 24227,
	"./smartphone-active.svg": 69489,
	"./smartphone.svg": 44882,
	"./star.svg": 40815,
	"./text-color.svg": 29856,
	"./trash.svg": 59272,
	"./triangle-white.svg": 27331,
	"./triangle.svg": 11907,
	"./visa.svg": 99468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;